import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DirectsPositionClassComparison } from '../../../models/directs-position-class-comparison.model';

@Component({
  selector: 'coin-c-directs-position-comparison-list',
  templateUrl: './directs-position-comparison-list.component.html',
  styleUrls: ['./directs-position-comparison-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DirectsPositionComparisonListComponent {
  @Input({ required: true }) comparisonEmployees: DirectsPositionClassComparison[];
}
